import WorkspacesIcon from '@mui/icons-material/Workspaces';
import { ItemsList } from './ItemsList';
import { ItemCreate } from './ItemCreate';
import { ItemEdit } from './ItemEdit';

const items = {
  list: ItemsList,
  create: ItemCreate,
  edit: ItemEdit,
  icon: WorkspacesIcon,
};

export default items;
